import { render, staticRenderFns } from "./headquarters.vue?vue&type=template&id=4cb50b18&scoped=true&"
import script from "./headquarters.vue?vue&type=script&lang=js&"
export * from "./headquarters.vue?vue&type=script&lang=js&"
import style0 from "./headquarters.vue?vue&type=style&index=0&id=4cb50b18&lang=scss&scoped=true&"
import style1 from "./headquarters.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb50b18",
  null
  
)

export default component.exports